<div class="duplicate-vehicle">

  <div class="ui-g-12 p-zero dialog-header">
    <div class="columns">
      <div class="icon">
        <div class="icon-circle ml-2"><i class="fal fa-car pt-1"></i></div>
      </div>
      <div class="text">
        <div class="font-16 font-bold black m-0 tml-heading">Matches found for VIN and license plate.</div>
        <div class="font-10 font-500 gray-55 tml-sub-header text-truncate">How do you want to proceed?</div>
      </div>
    </div>
    <div class="close">
      <i class="fal fa-times fa-sm dialog-close font-500" (click)="closeDuplicateVehicleeModal({})"></i>
    </div>
  </div>

  <div class="dialog-body">
    <div class="ui-g">

      <!-- Vehcile list for current customer -->
      <div class="ui-g-12" *ngIf="existingCustomerList?.length">
        <span *ngFor="let customer of existingCustomerList;let customerIndex = index">
          <div class="font-14 font-bold font-gray-45">Matching vehicles for {{customer?.customerName}}</div>
          <span *ngFor="let vehicle of customer?.vehicles;let vehicleIndex = index">
            <div class="columns vehicle-card-title mt-2 mb-3 pb-3 pb-3" >
              <div class="checkbox-vin mt-3 ml-2">
                <span [hidden]="isShowOnly">
                  <app-radio-button id="vehicle-{{vehicleIndex}}" [disabled]="isShowOnly" [value]="true" (appChange)="handleRadioChange('existing', 'isChecked', customerIndex,vehicleIndex, $event)" [selectedValue]="vehicle.isChecked" ></app-radio-button>
                </span>
              </div>
              <div class="vin">
                <div class="font-15 font-bold black mt-2 tml-heading text-truncate">{{vehicle?.vehicleName}}</div>
                <div class="font-13 font-500 gray-45 tml-sub-header">{{vehicle?.VIN}} <span *ngIf="vehicle?.licensePlateNo && vehicle?.VIN">/</span> {{vehicle?.licensePlateNo}}</div>
              </div>
            </div>
          </span>
        </span>

      </div>

      <!-- Vehcile list for other customers -->
      <div class="ui-g-12" *ngIf="OtherVehicleCustomer?.length">
        <div class="font-14 font-bold font-gray-45">Matching vehicles for other customers</div>
        <span *ngFor="let customer of OtherVehicleCustomer;let customerIndex = index">
          <span *ngFor="let vehicle of customer?.vehicles;let vehicleIndex = index">
            <div class="columns vehicle-card-title mt-2 mb-3 pb-3 pb-3" >
              <div class="checkbox-vin mt-3 ml-2">
                <span [hidden]="isShowOnly">
                  <app-radio-button id="vehicle-{{vehicleIndex}}" [disabled]="isShowOnly" [value]="true" (appChange)="handleRadioChange('other','isChecked',customerIndex, vehicleIndex, $event)" [selectedValue]="vehicle.isChecked" ></app-radio-button>
                </span>
              </div>
              <div class="vin">
                <div class="font-15 font-bold black mt-2 tml-heading text-truncate">{{vehicle?.vehicleName}}</div>
                <div class="font-13 font-500 gray-45 tml-sub-header">{{vehicle?.VIN}} <span *ngIf="vehicle?.licensePlateNo && vehicle?.VIN">/</span>  {{vehicle?.licensePlateNo}}</div>
                <div class="font-13 font-500 gray-45 tml-sub-header">{{customer?.customerName}} {{ customer?.customerIsActive ? '(Inactive)' : ''}}</div>
              </div>
            </div>
          </span>
        </span>

      </div>

    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="p-zero text-right float-right duplicate-vehicle-footer mt-1 mb-1" *ngIf="!isShowOnly">
      <button id="duplicate-vehicle-btn-cancel" class="btn btn-border pointer mr-1 font-bold mr-2"
        (click)="handleSubmit($event,'newVehicle')">Create new vehicle</button>
      <button id="duplicate-vehicle-btn-save" class="btn btn-primary btn-submit font-bold" [disabled]="!selectedVehicle?._id"
      (click)="handleSubmit($event,'updateVehicle')">
        <span class="">Change & Update</span>
        <i *ngIf="isLoading" class="fal fa-spinner rotate ml-1"></i>
      </button>
    </div>

    <div class="p-zero text-right float-right duplicate-vehicle-footer mt-1 mb-1" *ngIf="isShowOnly">
      <button id="btn-cancel" class="btn btn-white pointer btn-submit mr-2"
      (click)="closeDuplicateVehicleeModal({})">Back
    </button>
      <button id="btn-save" class="btn btn-primary btn-submit"
        (click)="handleSubmit($event,'showOnly')">Save changes
      </button>

    </div>
  </div>

</div>
